<template>
	<div class="text-effect-wrapper" >
		<div class="text-effect">
			<h1 class="neon" :class="'neon--' + size" :data-text="text" contenteditable>
				{{text}}
			</h1>
			<div class="gradient" :style="{ background: 'linear-gradient(45deg,' + color1 + ',' + color2 + ')' }"></div>
			<div class="spotlight"></div>
			<div class="mask"></div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Neon',
		props: {
			text: {
				type: String,
				default: 'Neon'
			},
			color1: {
				type: String,
				default: '#e8262f',
			},
			color2: {
				type: String,
				default: '#ffc800',
			},
			size: {
				type: String,
				default: 'regular',
			}
		},
	}
</script>
<style lang="scss">

.text-effect {
	overflow: hidden;
	position: relative;

	// The blend modes mute the colors, so let's bump them up
	filter: contrast(110%) brightness(190%);
}

.neon {
	width: 101%;
	font-size: clamp(60px, 12vw, 140px);
	font-weight: 600;
	text-transform: uppercase;
	text-align: center;
	margin: 0;
	&:focus { outline: none; border: 1px dotted white; }
	position: relative;

	// Only works on a black background, sorry
	background: black;

	// The actual text inside the div is superfluous, only data-text matters. The text is added so you can easily edit the preview
	color: transparent;

	&::before,
	&::after {
		// Add two copies of the text on their own layer
		content: attr(data-text);

		// White, so we can paint them later
		color: white;

		// And blur them to create the neon effect with the blend-mode below
		filter: blur(0.02em);

		position: absolute;
		top: 0; left: 0;
		pointer-events: none;
	}

	// Set the top copy to difference. This creates the knock-out effect with a bit of glow
	&::after {
		mix-blend-mode: difference;
	}

	&--small {
		font-size: clamp(48px, 7vw, 80px);
	}
}

// Position our two effect layers
.gradient,
.spotlight {
	position: absolute;
	top: 0; left: 0; bottom: 0; right: 0;
	pointer-events: none;
	z-index: 10;  
}

// Add the colors
.gradient {

	// Multiply mode will paint only the white text
	mix-blend-mode: multiply;
}

.spotlight {
	animation: light 5s infinite linear;

	// These are the lights, color-dodge needs a black bg for optimum effect
	background: 
	radial-gradient(circle, white, transparent 25%) 0 0 / 25% 25%, 
	radial-gradient(circle, white, black 25%) 50% 50% / 12.5% 12.5%;
	top: -100%; left: -100%;

	// Color dodge gives the lights that shimmer effect
	mix-blend-mode: color-dodge;
}
.mask {
	position: absolute;
	top: 0;
	left: 0;
	width: calc(100% + 1px);
	height: calc(100% + 1px);
	border: 2px solid black;
	z-index: 100;

}

@keyframes light {
	100% {
		transform: translate3d(50%, 50%, 0);
	}
}


// Center everything
.text-effect-wrapper {
	display: flex;
//	background-color: black;
	// min-height: 100vh;
	justify-content: center;
	align-content: center;
	align-items: center;
	overflow: hidden;
}

</style>